import { Divider } from "@mui/material";
import default_theme from "assets/themes/themes";

export default function FigmaBlueDivider() {
  return (
    <Divider
      sx={{
        my: 5,
        borderColor: default_theme.palette.other.figmaBlue,
        borderBottomWidth: 2,
      }}
    />
  );
}